// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-wrapper {
  position: relative;
  z-index: 1;
  margin-top: 6rem;
}

.step {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.step img{
  padding: 5px;
}

.step > div:first-child {
  width: 3.8rem;
  height: 3.8rem;
  background: #f7cffc;
  border: 1px solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step > div:first-child > p {
  font-size: 1.6rem;
  font-weight: 600;
  color: #3a3a3a;
}

.step > div.inactive {
  background: #e6e6e6;

  border: 1px solid #ffffff5e;
}

.step-info h2 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #C4C4C4;
}

.step-info p {
  font-size: 1.6rem;
  font-weight: 500;
  color: #8f8f8f;
}
.step.active h2 {
  color: #F7F4FF;
}
.progress-bar-wrapper {
  position: relative;
  height: 50px;
  width: 3px;
  margin-left: 17px;
  border-radius: 3px;
}
.step-progress-bar {
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 0;
  transition: background-color 0.3s ease;
  border-radius: 10px;
}

.step-progress-bar.active {
  background-color: #A1AEBE;
}

.step div {
  z-index: 1;
}

@media (max-width: 768px) {
  .steps-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2.5rem;
    padding: 0 2rem;
  }
  .step {
    margin: 0;
    padding-right: 4px;
  }

  .step-info h2 {
    margin: 0;
  }

  .step > div:first-child {
    width: 2.8rem;
    height: 2.8rem;
  }

  .step > div:first-child > p {
    font-size: 1.3rem;
  }
  .progress-bar-wrapper {
    display: none;
  }
  .step > img {
    width: 2.8rem;
    height: 2.8rem;
  }
}

@media (max-width: 600px) {
  .steps-wrapper {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 3rem;
    gap: 1.2rem;
    padding: 0;
  }
  .step-info p {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FormSteps/Steps.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;;EAEnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".steps-wrapper {\n  position: relative;\n  z-index: 1;\n  margin-top: 6rem;\n}\n\n.step {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n.step img{\n  padding: 5px;\n}\n\n.step > div:first-child {\n  width: 3.8rem;\n  height: 3.8rem;\n  background: #f7cffc;\n  border: 1px solid #ffffff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.step > div:first-child > p {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #3a3a3a;\n}\n\n.step > div.inactive {\n  background: #e6e6e6;\n\n  border: 1px solid #ffffff5e;\n}\n\n.step-info h2 {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #C4C4C4;\n}\n\n.step-info p {\n  font-size: 1.6rem;\n  font-weight: 500;\n  color: #8f8f8f;\n}\n.step.active h2 {\n  color: #F7F4FF;\n}\n.progress-bar-wrapper {\n  position: relative;\n  height: 50px;\n  width: 3px;\n  margin-left: 17px;\n  border-radius: 3px;\n}\n.step-progress-bar {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  z-index: 0;\n  transition: background-color 0.3s ease;\n  border-radius: 10px;\n}\n\n.step-progress-bar.active {\n  background-color: #A1AEBE;\n}\n\n.step div {\n  z-index: 1;\n}\n\n@media (max-width: 768px) {\n  .steps-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2.5rem;\n    padding: 0 2rem;\n  }\n  .step {\n    margin: 0;\n    padding-right: 4px;\n  }\n\n  .step-info h2 {\n    margin: 0;\n  }\n\n  .step > div:first-child {\n    width: 2.8rem;\n    height: 2.8rem;\n  }\n\n  .step > div:first-child > p {\n    font-size: 1.3rem;\n  }\n  .progress-bar-wrapper {\n    display: none;\n  }\n  .step > img {\n    width: 2.8rem;\n    height: 2.8rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .steps-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 3rem;\n    gap: 1.2rem;\n    padding: 0;\n  }\n  .step-info p {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
